import { render, staticRenderFns } from "./worker-manage.vue?vue&type=template&id=4db35b93&scoped=true&"
import script from "./worker-manage.vue?vue&type=script&lang=js&"
export * from "./worker-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db35b93",
  null
  
)

export default component.exports